import { EvPlugChademoIcon } from './EvPlugChademoIcon';

/**
 * author: Michael Irigoyen
 * id C2C4C1DC-0FB1-4A1A-AA85-8FD1D8DF4532
 * name ev-plug-chademo
 * version: 5.4.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/ev-plug-chademo.svg
 * tags
 * - Automotive 
 */
export const EvChargerChademoIcon = EvPlugChademoIcon;
export default EvChargerChademoIcon